// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__Q8Dbe","checkboxDisabled":"checkbox_checkboxDisabled__F9XzI"};